module.exports = __webpack_public_path__ + "img/logo_instagram.622e2947.svg";